import request from "@/utils/request";

// 创建课程视
export const  createHumanityCourse =(data) =>{
    return request({
        url: "/businessservice/humanityCourse/create",
        method:"post",
        data: data
    })
}

// 更新课程
export const  updateHumanityCourse =(data) =>{
    return request({
        url: "/businessservice/humanityCourse/update",
        method:"post",
        data: data
    })
}

// 分页课程
export const  pageHumanityCourse =(data) =>{
    return request({
        url: "/businessservice/humanityCourse/page",
        method:"post",
        data: data
    })
}


// 课程详情
export const  infoHumanityCourse =(query) =>{
    return request({
        url: "/businessservice/humanityCourse/info",
        method:"get",
        params: query
    })
}

// 分页课程
export const  listHumanityCourse =(data) =>{
    return request({
        url: "/businessservice/humanityCourse/list",
        method:"post",
        data: data
    })
}